import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, mergeMap, of } from 'rxjs';
import { AdminSessionProfileService } from '../services/admin-session-profile.service';
import { PermissionService } from '../services/permission.service';

/**
 * Blocks `AppLayout` (and every page under it) until `GET /user/admin/profile` succeeds.
 * Loads profile into {@link AdminSessionProfileService} for the header.
 * On failure returns a `UrlTree` to sign-in with optional `returnUrl` (Angular-recommended redirect).
 */
export const adminSessionGuard: CanActivateFn = (_route, state) => {
  const profile = inject(AdminSessionProfileService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const returnUrl = state.url && state.url.length > 0 ? state.url : '/';
  return profile.loadProfile().pipe(
    mergeMap(() =>
      permissionService.ensureLoaded().pipe(
        map(() => true),
      ),
    ),
    catchError(() =>
      of(
        router.createUrlTree(['/auth/signin'], {
          queryParams: returnUrl === '/' ? undefined : { returnUrl },
        }),
      ),
    ),
  );
};
